export default "__VITE_ASSET__BjBNupfR__"